import * as types from './types'

export const popNotify = (typeItem) => dispatch => {
    dispatch({
        type: types.POP_NOTIFY,
        payload: {
            typeItem
        }
    })
}

export const logoutByTimeout = () => ({
    type: types.LOGOUT_BY_TIMEOUT
})